import React from 'react'
import YearlyTarget from './YearlyTarget'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const AdminYearlyTarget = () => {

  const addYearlyTargetPermission = checkPermission(
    permissionsConfig.addYearlyTarget.role,
    permissionsConfig.addYearlyTarget.action,
    permissionsConfig.addYearlyTarget.type
  );
  
  return (
    <YearlyTarget title="Yearly Target" showAction={true} addYearlyTargetPermission={addYearlyTargetPermission}></YearlyTarget>
  )
}

export default AdminYearlyTarget